module.exports = __webpack_public_path__ + "static/media/tier-8.dc26dd42.jpg";